import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AnnotationSharedModule } from '../../outputs/annotation/annotation-shared/annotation-shared.module';
import { NestableOutputsModule } from '../../outputs/nestable/nestable-outputs.module';
import { CvFeedbackPanelComponent } from '../feedback/views/cv-feedback-panel/cv-feedback-panel.component';
import { FieldFeedbackOutputFooterComponent } from '../feedback/views/field-feedback-output-footer/field-feedback-output-footer.component';
import { NakedOutputComponent } from '../outputs/naked-output.component';
import { OutputsModule } from '../outputs/outputs.module';
import { SubmitTaskButtonComponent } from '../production-workspace/submit-task-button/submit-task-button.component';
import { SharedModule } from '../shared/shared.module';
import { DataDirective } from './data.directive';
import { ColumnComponent } from './dsl/column.component';
import { ImageComponent } from './dsl/image.component';
import { InfoComponent } from './dsl/info.component';
import { OutputComponent } from './dsl/outputs/output.component';
import { RowComponent } from './dsl/row.component';
import { SensorFusionComponent } from './dsl/sensor-fusion/sensor-fusion.component';
import { H3mlContainerComponent } from './h3ml-container.component';
import { RootH3mlContainerComponent } from './root-h3ml-container.component';

const exportedItems = [
  ColumnComponent,
  DataDirective,
  H3mlContainerComponent,
  ImageComponent,
  InfoComponent,
  OutputComponent,
  RootH3mlContainerComponent,
  RowComponent,
  SensorFusionComponent,
  SubmitTaskButtonComponent,
];

@NgModule({
  imports: [
    AnnotationSharedModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatExpansionModule,
    MatTabsModule,
    MatTooltipModule,
    NestableOutputsModule,
    OutputsModule,
    SharedModule,
    FieldFeedbackOutputFooterComponent,
    CvFeedbackPanelComponent,
  ],
  declarations: [exportedItems],
  exports: [exportedItems, NakedOutputComponent],
})
export class H3mlModule {}
